import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { editSchedule } from '../actions/EditSchedule';
import { ScheduleTime } from '../features/schedules/ScheduleTime';
import { ScheduleOperation } from '../features/schedules/ScheduleOperation';
import { ScheduleNextRun } from '../features/schedules/ScheduleNextRun';
import { DeviceLink } from '../features/devices/DeviceLink';
export const ConfigScheduleRow = (props) => {
    const dispatch = useAppDispatch();
    const schedules = useAppSelector(state => state.definitions.schedules.entities);
    const devices = useAppSelector(state => state.definitions.devices);
    const schedule = schedules[props.id];
    if (schedule == undefined) {
        return null;
    }
    const device = devices[schedule.device_id];
    if (device == undefined) {
        return null;
    }
    return (_jsxs("div", { className: "config-schedule-row", children: [_jsx("div", { style: { whiteSpace: 'nowrap' }, children: _jsx(ScheduleTime, Object.assign({}, schedule.time)) }), _jsx(ScheduleNextRun, { schedule: schedule }), _jsx(ScheduleOperation, { schedule: schedule }), _jsx("div", { children: _jsx(DeviceLink, { device_id: device.id }) }), _jsx("div", { children: _jsx("button", { className: "edit lw small", onClick: () => dispatch(editSchedule(props.id)), children: "\u00A0Redigera\u00A0" }) })] }, props.id));
};
